import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import HeaderV2 from '../components/HeaderV2';
import FooterV2 from '../components/FooterV2';
import FunctionalHeroV2 from '../components/FunctionalHeroV2';
import CheckoutPage from './CheckoutPage';

/**
 * CheckoutV2Page
 * Barista Map 風格 V2 殼：壓縮版 Hero + 奶油色功能區。
 * 內容沿用 CheckoutPage（藍新 NewebPay / EZShip / Stripe 流程一律不動）。
 *
 * 對應路由：/zh/checkout/v2、/en/checkout/v2
 * SEO：noindex,follow + canonical 指回舊版 /[lang]/checkout
 */
export default function CheckoutV2Page() {
  const location = useLocation();
  const isEn = location.pathname.startsWith('/en');
  const lang = isEn ? 'en' : 'zh';
  const canonicalUrl = `https://www.ongucoffee.com/${lang}/checkout`;
  const isPreviewRoute = location.pathname.includes('/v2');

  useEffect(() => {
    const fontId = 'v2-fonts-checkout';
    if (!document.getElementById(fontId)) {
      const link = document.createElement('link');
      link.id = fontId;
      link.rel = 'stylesheet';
      link.href =
        'https://fonts.googleapis.com/css2?family=EB+Garamond:ital,wght@0,400;0,500;1,400&family=Noto+Serif+TC:wght@300;400;500&display=swap';
      document.head.appendChild(link);
    }
  }, []);

  const eyebrow = isEn ? 'Secure Checkout' : '安全結帳';
  const title = isEn ? 'Checkout' : '結帳';
  const subtitle = isEn
    ? 'Complete your order with care — packed, roasted, and shipped from Taipei.'
    : '從烘焙到出貨，每一步都經由我們親手完成。';

  return (
    <>
      {/* /v2 預覽路由才 noindex；換骨後讓內嵌 CheckoutPage 自帶 SEO 接管 */}
      {isPreviewRoute && (
        <Helmet>
          <meta name="robots" content="noindex,follow" />
          <link rel="canonical" href={canonicalUrl} />
        </Helmet>
      )}
      <div className="min-h-screen bg-white">
        <HeaderV2 />
        <FunctionalHeroV2
          eyebrow={eyebrow}
          title={title}
          subtitle={subtitle}
          backgroundImage="https://images.pexels.com/photos/4109747/pexels-photo-4109747.jpeg?auto=compress&cs=tinysrgb&w=1920"
          breadcrumbs={[
            { label: isEn ? 'Home' : '首頁', to: `/${lang}` },
            { label: isEn ? 'Cart' : '購物車', to: `/${lang}/cart/v2` },
            { label: isEn ? 'Checkout' : '結帳' },
          ]}
        />
        <main className="bg-[#f5f1ea]">
          <div className="mx-auto max-w-[1600px] px-4 md:px-8 py-10 md:py-16">
            <CheckoutPage />
          </div>
        </main>
        <FooterV2 />
      </div>
    </>
  );
}
